module.exports = __webpack_public_path__ + "img/logo.37f2bc6e.svg";